import {
  Button,
  Grid,
  IconButton,
} from "@mui/material";
import "./newquestion.scss";
import React, { useEffect, useState } from "react";
import { Box } from "@mui/system";
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";
import Buttons from "../../Controls/Buttons/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import FormHelperText from "@mui/material/FormHelperText";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";

const QuestionNameInput = ({
  newQuestionIndex,
  newQuestion,
  handleNewQuestionNameChange,
  validation,
}) => {
  const [value, setValue] = useState(newQuestion?.question);

  const onChange = (value) => {
    setValue(value);
  };
  return (
    <div
    // className="cell-outer"
    >
      <TextField
        fullWidth
        id="outlined-basic"
        variant="outlined"
        placeholder="Question"
        value={value}
        onChange={(e) => onChange(e.target.value, newQuestionIndex)}
        onBlur={(e) => handleNewQuestionNameChange(value, newQuestionIndex)}
      />
    </div>
  );
};

const NewQuestion = ({ handleAddQuestion }) => {
  const [newQuestions, setNewQuestions] = useState([]);
  const [newQuestionCount, setNewquestionCount] = useState("");

  const [openModal, setOpenModal] = useState(false);
  const [validation, setValidation] = useState({
    isError: false,
    message: "",
  });

  useEffect(() => {
    if (!openModal) {
      setNewQuestions([]);
      setNewquestionCount("");
      setOpenModal(false);
    }
  }, [openModal]);

  const handleAdNewQuestionChange = (value) => {
    // setNewquestionCount(value);
    const trimmedValue = value.replace(/^0+/, "");

    if (/^-?\d*$/.test(trimmedValue) && trimmedValue.length <= 3) {
      setNewquestionCount(value);
    }
  };

  // below logic for new questions data

  const addNewQuestionClick = () => {
    const questionsToAdd = [];
    for (let i = 0; i < newQuestionCount; i++) {
      questionsToAdd.push({
        question: "",
      });
    }
    setNewQuestions([...newQuestions, ...questionsToAdd]);
    setNewquestionCount("");
  };

  const handleNewQuestionNameChange = (value, index) => {
    newQuestions[index].question = value;
    setNewQuestions(newQuestions);
    setValidation({ ...validation, isError: false, message: "" });
  };

  const handleDeleteQuestion = (newQuestionIndex) => {
    newQuestions.splice(newQuestionIndex, 1);
    setNewQuestions([...newQuestions]);
  };

  const onClickAddQuestionButton = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
    setValidation({ isError: false, message: "" });
  };

  const onClickAddQuestion = (newQuestions) => {
    // Check if there are duplicates in question names
    const hasDuplicates = (arr) =>
      new Set(arr.map((questions) => questions.question)).size !== arr.length;

    const isQuestionEmpty = (question) => question.question !== "";

    const isAllFilledQuestionNameInput = newQuestions.every(isQuestionEmpty);

    if (isAllFilledQuestionNameInput && !hasDuplicates(newQuestions)) {
      handleAddQuestion(newQuestions);
      setOpenModal(false);
      setNewQuestions([]);
      setValidation({ isError: false, message: "" });
    } else {
      setValidation({
        ...validation,
        isError: true,
        message: "Check for duplicate or empty question names.",
      });
    }
  };

  return (
    <>
      <Buttons
        className="add_new_question"
        text={"Add New Questions"}
        onClick={onClickAddQuestionButton}
        size="small"
      />
      {/* Add new question Button */}

      {openModal && (
        <Dialog
          fullWidth={true}
          maxWidth={"sm"}
          open={openModal}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">Add New Questions</DialogTitle>
          <DialogContent className="add-new-question-modal">
            <>
              <Grid className="new-question-container" container>
                <Box className="new-question-wrap">
                  <div className="new-question-label">
                    <IconButton
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                      onClick={handleClose}
                    >
                      <CloseIcon />
                    </IconButton>
                    {/* <Tooltip title="Max Count 3" arrow> */}
                    <TextField
                      className="input-text"
                      placeholder="No of Questions"
                      size="small"
                      value={newQuestionCount}
                      onChange={(e) =>
                        handleAdNewQuestionChange(e.target.value)
                      }
                      type="text"
                    />
                    {/* </Tooltip> */}
                  </div>
                  <Button
                    onClick={(e) => addNewQuestionClick()}
                    variant="contained"
                    style={{ paddingLeft: "20px" }}
                  >
                    Add
                  </Button>
                  {/* <IconButton
                    aria-label="toggle password visibility"
                    onClick={(e) => addNewQuestionClick()}
                    edge="end"
                    size="large"
                  >
                    <AddCircleOutlineRounded className="plusIcon" />
                  </IconButton> */}
                </Box>
                <FormHelperText>{"Number of questions to add."}</FormHelperText>
                {validation?.isError && (
                  <FormHelperText error variant="outlined">
                    {validation?.message}
                  </FormHelperText>
                )}
              </Grid>
              <br></br>

              {newQuestions.length > 0 &&
                newQuestions.map((newQuestion, newQuestionIndex) => (
                  <Grid container className="question-add">
                    <Grid item xs={11}>
                      <QuestionNameInput
                        newQuestionIndex={newQuestionIndex}
                        newQuestion={newQuestion}
                        handleNewQuestionNameChange={
                          handleNewQuestionNameChange
                        }
                      />
                    </Grid>

                    <Grid item xs={1}>
                      <IconButton
                        aria-label="delete-question"
                        onClick={(e) => handleDeleteQuestion(newQuestionIndex)}
                        edge="end"
                      >
                        <DeleteForeverOutlinedIcon />
                      </IconButton>
                    </Grid>
                  </Grid>
                ))}
            </>
          </DialogContent>
          <DialogActions>
            <Button
              className="btn-add-question"
              variant="contained"
              onClick={(e) => onClickAddQuestion(newQuestions)}
              disabled={newQuestions.length <= 0}
            >
              Add Questions
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </>
  );
};

export default NewQuestion;
